// extracted by mini-css-extract-plugin
export default {"contactText":"Contact_contactText__07Zcu","link":"Contact_link__T3v-S"};